import { createFileRoute } from '@tanstack/react-router';
import { HushedFrame } from '../screens/auth/HushedFrame';
import { ForgotPasswordPage } from '../screens/auth/ForgotPasswordPage';

/** A forgotten password: the address, then "Check your email". No sign-in, on sign-in's own ground. */
export const Route = createFileRoute('/forgot-password')({
  component: RouteComponent,
});

function RouteComponent() {
  return <ForgotPasswordPage Frame={HushedFrame} />;
}
